import React, { useCallback, useEffect } from 'react';
import { bool, number, func } from 'prop-types';
import { useDispatch } from 'react-redux';

import { Modal } from 'src/common/modal';
import { Button } from 'src/common/button';
import { useStatus } from 'src/hooks';
import { LOADING, SUCCESS, ERROR } from 'src/constants/status';
import { DELETE_EDITOR, deleteEditor } from 'src/actions/accountActions';
import { reset } from 'src/actions/statusActions';
import styles from './DeleteEditor.module.scss';

const DeleteEditor = ({ isShowing, hide, editorId }) => {
  const dispatch = useDispatch();

  const onDelete = useCallback(() => {
    dispatch(deleteEditor(editorId));
  }, [dispatch, editorId]);

  const { status: statusDelete } = useStatus(DELETE_EDITOR);

  useEffect(() => {
    if (statusDelete === SUCCESS) {
      hide();
    }

    return () => {
      if (statusDelete === SUCCESS || statusDelete === ERROR) {
        dispatch(reset(DELETE_EDITOR));
      }
    };
  }, [statusDelete, hide, dispatch]);

  return (
    <Modal
      isShowing={isShowing}
      hide={hide}
      curvedContainer
      classNameContent={styles.modal}
      closeOnClickOutside={false}
    >
      <div className={styles.content}>
        <span className={styles.title}>
          Delete your Editor?
        </span>
        <span className={styles.subtitle}>
          The editor will no longer have access to the account or the account’s projects.
          Are you sure you want to remove the selected editor?
        </span>
        <div className={styles.buttonsContainer}>
          <Button
            className={styles.button}
            onClick={onDelete}
            alternativeCTA
            loading={statusDelete === LOADING}
          >
            I&apos;m sure
          </Button>
          <Button
            className={styles.buttonDelete}
            onClick={hide}
            disabled={statusDelete === LOADING}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

DeleteEditor.propTypes = {
  isShowing: bool.isRequired,
  hide: func.isRequired,
  editorId: number.isRequired,
};

export { DeleteEditor };
